export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-the-final-accounts': 'Imprimir cuentas finales',
    'unlock-accounts': 'Cancelar el cierre de cuentas',
    'lock-accounts': 'Cierre de cuentas',

    account: {
        operations: 'Explotación',
        trade: 'Mercancía',
        'gains-and-losses': 'Pérdidas y ganancias',
        budget: 'Balance general',
    },

    'unlock-current-financial-file-accounts': 'Cancelar el cierre de archivo financiero',
    'are-you-sure-you-want-to-unlock-accounts': '¿estas seguro de cancelar el cierre de cuentas?',

    'lock-financial-file-accounts': 'Cierre de cuentas de archivo financiero',

    'operations-account-balance': 'Saldo de explotación',
    'trade-account-balance': 'Saldo de mercancía',
    'gains-and-losses-account-balance': 'Saldo de pérdidas y ganancias',
    'budget-account-balance': 'Saldo de balance general',
    
    'lock': 'Cierre',
    'next': 'Seguinte',
    'previous': 'Anterior',
    'cancel': 'Cancelar',
    'lock-dialog': {
        'checking-all-bonds-are-posted': 'Todos los bonos están arrastrados',
        'checking-all-invoices-are-posted': 'Todas las facturas están arrastradas',
        'checking-all-material-journals-are-posted': 'Todos los diarios están arrastrados',
        'checking-all-manufacturing-bonds-are-posted': 'Todos los bonos de fabrecación están arrastrados',
        'checking-no-negative-values-for-materials': 'No materiales con saldos negativos',

        'radio-select': 'Seleccionar',
        'radio-create': 'Crear',

        'stepper-validate': 'Verficar',
        'stepper-lock-accounts': 'Cerrar cuentas',
        'stepper-lock': 'Cerrar cuentas',

        'the-profit-and-loss-account': 'Cuenta rotativa de pérdidas y ganancias',
        'the-materials-end-of-term-account': 'Cuenta de inventario final',
        'it-is-set-in-financial-file-accounts': 'Asignado desde la página de configuración',

        'account': 'Cuenta',
        'new-account-parent': 'Cuenta principal',
        'new-account-name': 'Nombre de cuenta',

        'account-create-note': '*Nota: la cuenta se creará como una subcuenta y su cuenta final será el balance general',

        details: `
        <span class="primary--text" style="font-size: 1rem">Después de cerrar este archivo:</span> <br>
        -   Se crearán como cuentas de balance las siguientes cuentas: Cuenta de inventario final - Cuenta de pérdidas y ganancias rotativa (en caso de que no existan).<br>
        -   Se creará un bono de cierre que incluirá:<br>
            • Asientos de cierre para todas las cuentas que no sean de saldo en una naturaleza distinta de sus saldos (crédito o débito).<br>
            • Asientos de débito para la cuenta de inventario final con la cantidad de inventario que todavía está disponible al final del período contable.<br>
            • Asiento de débito o crédito de la cuenta de pérdidas y ganancias rotativas con el saldo de pérdidas y ganancias.<br>
        -   El archivo financiero se bloqueará para editar y solo el administrador puede abrir el archivo financiero.
        `
    },

    'sorry-you-can-not-close-the-financial-file-because-of-the-unposted-bonds-with-the-numbers' : 'Lo sentimos, no es posible cerrar el archivo financiero debido a los bonos no registrados con números',

    'rerotate-financial-file': '¿Volver a rotar el archivo financiero?',
    'do-you-want-to-rerotate-financial-file': 'El archivo financiero ya está girado al archivo financiero: "{archivo financiero}". Si el proceso de rotación anterior no se completa, se reanudará o volverá a girar el archivo financiero. Siempre puedes forzar la re-rotación cuando quieras. ¿Quieres continuar?',

    'rotate': 'Rotar al nuevo archivo financiero',
    're-rotate': 'Volver a rotar',
    'resume': 'Reanudar',
    'rotate-dialog': {
        'stepper-validate': 'Verificar',
        'stepper-financial-file': 'Crear archivo financiero',
        'stepper-move-trees': 'Mover cuentas y artículos',
        'stepper-rotate': 'Rotar a nuevo archivo financiero',
        'stepper-rotate-steps': 'Rotar pasos',

        'financial-file-is-locked': 'El archivo financiero está cerrado ... puede continuar',
        'financial-file-is-not-locked': 'El archivo financiero no está cerrado',

        'rotate-financial-file': 'Rotar el archivo financiero',
        'new-financial-file-name': 'Nombre del nuevo archivo financiero',
        'fiscal-year-name': 'Nombre del año fisical',
        'start-fiscal-year': 'Inicio del año fisical',
        'end-fiscal-year': 'Fin de año fisical',
        'move-accounts-tree': 'Mover cuentas',
        
        'first-term-account': {
            text: 'Inventario de inicio',
            'account-parent': 'Cuenta principal',
            'account-name': 'Nombre de cuenta',
            'account-no': 'Número de cuenta de inventario inicial',
        },

        'move-materials-trees': 'Mover artículos',
        'same-parent-no': 'El número de cuenta está reservado.',
        'the-financial-file-is-ready-to-rotate': 'El archivo financiero está listo para rotar haga clic en "rotar" para confirmar',
        details: `
        <span class="primary--text" style="font-size: 1rem">Cuando se rote el archivo financiero, se hará lo siguiente:</span><br>
        -   Crear un nuevo archivo de año fiscal, con la misma moneda predeterminada que el archivo anterior.<br>
        -   Se otorgarán permisos de acceso al nuevo archivo serán los mismos para el antiguo (el administrador puede editar sus permisos).<br>
        -   Mover todas las cuentas y estados personalizados del archivo anterior al archivo nuevo.<br>
        -   Se creará un bono de apertura, que incluirá los saldos de las cuentas permanentes (balance general) y saldo de inventario inicial, que será igual al inventario final del período contable anterior.<br>
        -   Todos los almacenes y artículos serán trasladados.<br>
        -   Los artículos del inventario de los almacenes se valorarán en función de:<br>
            • Los precios de inventario de los artículos (que se asignan desde la página de Inventario de artículos), y si hay artículos con precios no especificados, se utilizará el último precio de compra.<br>
        -   Se creará un diario de artículos de apertura, que incluirá las cantidades de artículos del período contable anterior.<br>
        `,

        steps: {
            'create-new-financial-file': 'Crear nuevo archivo financiero',
            'move-accounts-tree': 'Mover árbol de cuentas',
            'move-custom-statements': 'Mover declaraciones personalizadas',
            'move-item-trees': 'Mover árboles de elementos',
            'create-opening-accounting-bond': 'Crear bono contable de apertura',
            'create-opening-items-journal': 'Crear diario de artículos de apertura',
            'init-access-permissions': 'Inicializando permisos',
        },
        'in-progress': 'en curso',

        'wait-please': 'Tardará unos minutos, gracias por su paciencia.',
    }
}